import { Layout } from "@/components/Layout";

export default function PrivacyPolicy() {
  return (
    <Layout>
      <div className="container-main py-12">
        <div className="max-w-3xl mx-auto">
          <h1 className="text-4xl font-serif font-bold text-foreground mb-8">Política de Privacidad</h1>
          
          <div className="prose prose-stone max-w-none">
            <p className="text-stone-600 mb-6">
              Última actualización: {new Date().toLocaleDateString('es-MX', { year: 'numeric', month: 'long', day: 'numeric' })}
            </p>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-foreground mb-4">1. Introducción</h2>
              <p className="text-stone-600 leading-relaxed">
                En Apoyum, valoramos y respetamos su privacidad. Esta Política de Privacidad describe cómo 
                recopilamos, usamos, compartimos y protegemos su información personal cuando utiliza nuestra 
                plataforma.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-foreground mb-4">2. Información que Recopilamos</h2>
              <h3 className="text-xl font-medium text-foreground mb-3">2.1 Información que usted proporciona:</h3>
              <ul className="list-disc pl-6 text-stone-600 space-y-2 mb-4">
                <li><strong>Datos de cuenta:</strong> Nombre, correo electrónico, número de teléfono (opcional).</li>
                <li><strong>Información de pago:</strong> Procesada de forma segura por Stripe (no almacenamos datos de tarjeta).</li>
                <li><strong>Perfil de listener:</strong> Biografía, foto, video de presentación, zona horaria.</li>
              </ul>
              
              <h3 className="text-xl font-medium text-foreground mb-3">2.2 Información recopilada automáticamente:</h3>
              <ul className="list-disc pl-6 text-stone-600 space-y-2">
                <li><strong>Datos de uso:</strong> Páginas visitadas, tiempo en la plataforma, acciones realizadas.</li>
                <li><strong>Información del dispositivo:</strong> Tipo de navegador, sistema operativo, dirección IP.</li>
                <li><strong>Ubicación aproximada:</strong> Basada en IP para sugerir moneda de pago (USD/MXN).</li>
              </ul>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-foreground mb-4">3. Cómo Usamos su Información</h2>
              <p className="text-stone-600 leading-relaxed mb-4">
                Utilizamos su información para:
              </p>
              <ul className="list-disc pl-6 text-stone-600 space-y-2">
                <li>Proporcionar y mejorar nuestros servicios.</li>
                <li>Procesar pagos y transacciones.</li>
                <li>Enviar recordatorios de sesiones y notificaciones importantes.</li>
                <li>Conectar usuarios con listeners apropiados.</li>
                <li>Prevenir fraude y garantizar la seguridad de la plataforma.</li>
                <li>Cumplir con obligaciones legales.</li>
              </ul>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-foreground mb-4">4. Notas y Resúmenes de Sesión</h2>
              <div className="bg-blue-50 border border-blue-200 rounded-lg p-4 mb-4">
                <p className="text-blue-800 leading-relaxed">
                  <strong>Importante:</strong> Los listeners pueden tomar notas privadas sobre las sesiones para 
                  mejorar la continuidad del servicio. Estas notas son procesadas por inteligencia artificial 
                  para generar resúmenes anónimos que pueden ser visibles a otros listeners aprobados.
                </p>
              </div>
              <ul className="list-disc pl-6 text-stone-600 space-y-2">
                <li>Las notas privadas solo son visibles para el listener que las escribió.</li>
                <li>Los resúmenes generados por IA NO contienen información identificable.</li>
                <li>Puede solicitar la eliminación de sus datos en cualquier momento.</li>
              </ul>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-foreground mb-4">5. Compartir Información</h2>
              <p className="text-stone-600 leading-relaxed mb-4">
                No vendemos su información personal. Podemos compartir datos con:
              </p>
              <ul className="list-disc pl-6 text-stone-600 space-y-2">
                <li><strong>Proveedores de servicios:</strong> Stripe (pagos), Resend (emails), Google (autenticación).</li>
                <li><strong>Listeners:</strong> Información necesaria para la sesión (nombre, hora de cita).</li>
                <li><strong>Autoridades legales:</strong> Cuando sea requerido por ley o para proteger derechos.</li>
              </ul>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-foreground mb-4">6. Seguridad de Datos</h2>
              <p className="text-stone-600 leading-relaxed">
                Implementamos medidas de seguridad técnicas y organizativas para proteger su información:
              </p>
              <ul className="list-disc pl-6 text-stone-600 space-y-2 mt-2">
                <li>Encriptación de datos en tránsito (HTTPS/TLS).</li>
                <li>Almacenamiento seguro en servidores protegidos.</li>
                <li>Acceso restringido a información personal.</li>
                <li>Monitoreo continuo de seguridad.</li>
              </ul>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-foreground mb-4">7. Sus Derechos</h2>
              <p className="text-stone-600 leading-relaxed mb-4">
                Usted tiene derecho a:
              </p>
              <ul className="list-disc pl-6 text-stone-600 space-y-2">
                <li><strong>Acceder:</strong> Solicitar una copia de sus datos personales.</li>
                <li><strong>Rectificar:</strong> Corregir información inexacta.</li>
                <li><strong>Eliminar:</strong> Solicitar la eliminación de sus datos ("derecho al olvido").</li>
                <li><strong>Portabilidad:</strong> Recibir sus datos en formato legible.</li>
                <li><strong>Oposición:</strong> Oponerse al procesamiento de sus datos.</li>
              </ul>
              <p className="text-stone-600 leading-relaxed mt-4">
                Para ejercer estos derechos, contacte a:{" "}
                <a href="mailto:privacidad@apoyum.com" className="text-primary hover:underline">privacidad@apoyum.com</a>
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-foreground mb-4">8. Cookies</h2>
              <p className="text-stone-600 leading-relaxed">
                Utilizamos cookies esenciales para el funcionamiento del sitio y cookies de preferencias 
                (como recordar si el video está en silencio). No utilizamos cookies de seguimiento publicitario.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-foreground mb-4">9. Retención de Datos</h2>
              <p className="text-stone-600 leading-relaxed">
                Conservamos su información mientras mantenga una cuenta activa o según sea necesario para 
                proporcionar servicios. Los datos de sesiones se conservan por 2 años para fines de calidad 
                y resolución de disputas.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-foreground mb-4">10. Menores de Edad</h2>
              <p className="text-stone-600 leading-relaxed">
                Apoyum no está destinado a menores de 18 años. No recopilamos conscientemente información 
                de menores. Si descubrimos que un menor ha proporcionado datos, eliminaremos esa información.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-foreground mb-4">11. Cambios a esta Política</h2>
              <p className="text-stone-600 leading-relaxed">
                Podemos actualizar esta política periódicamente. Le notificaremos cambios significativos 
                por correo electrónico o mediante un aviso en la plataforma.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-foreground mb-4">12. Contacto</h2>
              <p className="text-stone-600 leading-relaxed">
                Para preguntas sobre esta Política de Privacidad:
              </p>
              <ul className="list-none text-stone-600 mt-2">
                <li>Email: <a href="mailto:privacidad@apoyum.com" className="text-primary hover:underline">privacidad@apoyum.com</a></li>
              </ul>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-foreground mb-4">13. Cumplimiento Legal</h2>
              <p className="text-stone-600 leading-relaxed">
                Esta política cumple con:
              </p>
              <ul className="list-disc pl-6 text-stone-600 space-y-2 mt-2">
                <li>Ley Federal de Protección de Datos Personales (México)</li>
                <li>California Consumer Privacy Act (CCPA)</li>
                <li>Principios generales del GDPR (Unión Europea)</li>
              </ul>
            </section>
          </div>
        </div>
      </div>
    </Layout>
  );
}
